/**
 * Gestion du formulaire de contact multi-étapes
 */

class ContactForm {
    constructor() {
        let cache = {};
        
        let initFunc = () => {
            initCache();
            registerEvents();
            setTimeout(() => {
                validateStep1();
            }, 500);
        };

        let initCache = () => {
            cache.formSection = document.getElementById('contact-form-section');
            cache.thankYouSection = document.getElementById('thank-you-section');
            cache.form = cache.formSection ? cache.formSection.querySelector('.wpcf7-form') : null;
            cache.nextButton = cache.form ? cache.form.querySelector('.cf7mls_next') : null;
            cache.step1Fields = null;
        };

        let registerEvents = () => {
            if (cache.formSection && cache.thankYouSection) {
                document.addEventListener('wpcf7mailsent', handleFormSuccess, false);
                
                document.addEventListener('wpcf7invalid', handleFormError, false);
                document.addEventListener('wpcf7spam', handleFormError, false);
                document.addEventListener('wpcf7mailfailed', handleFormError, false);
            }

            // Validation en temps réel pour l'étape 1
            if (cache.form) {
                cache.form.addEventListener('input', handleInputChange);
                cache.form.addEventListener('change', handleInputChange);
            }

            // Scroll automatique lors du changement d'étape
            if (cache.nextButton) {
                cache.nextButton.addEventListener('click', handleStepChange);
            }

            // Observer les changements d'étape (pour le bouton retour aussi)
            if (cache.form) {
                const observer = new MutationObserver(handleStepMutation);
                observer.observe(cache.form, {
                    attributes: true,
                    subtree: true,
                    attributeFilter: ['class']
                });
            }
        };

        let handleInputChange = (event) => {
            const currentStep = cache.form.querySelector('.fieldset-cf7mls.cf7mls_current_fs');
            if (currentStep && currentStep.getAttribute('data-cf7mls-order') === '0') {
                validateStep1();
            }
        };

        let handleStepChange = () => {
            setTimeout(() => {
                scrollToCurrentStep();
            }, 100);
        };

        let handleStepMutation = (mutations) => {
            mutations.forEach(mutation => {
                if (mutation.target.classList.contains('cf7mls_current_fs')) {
                    scrollToCurrentStep();
                }
            });
        };

        let scrollToCurrentStep = () => {
            const currentStep = cache.form.querySelector('.fieldset-cf7mls.cf7mls_current_fs');
            if (currentStep) {
                const stepTop = currentStep.getBoundingClientRect().top + window.pageYOffset;
                const offset = 100;
                
                window.scrollTo({
                    top: stepTop - offset,
                    behavior: 'smooth'
                });
            }
        };

        let validateStep1 = () => {
            if (!cache.form || !cache.nextButton) return;

            const currentStep = cache.form.querySelector('.fieldset-cf7mls.cf7mls_current_fs');
            if (!currentStep || currentStep.getAttribute('data-cf7mls-order') !== '0') return;

            const requiredFields = currentStep.querySelectorAll('input[aria-required="true"], textarea[aria-required="true"], select[aria-required="true"]');
            let allFilled = true;

            requiredFields.forEach(field => {
                if (field.type === 'checkbox' || field.type === 'radio') {
                    const name = field.name;
                    const checked = currentStep.querySelector(`input[name="${name}"]:checked`);
                    if (!checked) {
                        allFilled = false;
                    }
                } else {
                    if (!field.value || field.value.trim() === '') {
                        allFilled = false;
                    }
                }
            });

            if (allFilled) {
                cache.nextButton.disabled = false;
                cache.nextButton.classList.remove('disabled');
            } else {
                cache.nextButton.disabled = true;
                cache.nextButton.classList.add('disabled');
            }
        };

        let handleFormSuccess = (event) => {
            console.log('Formulaire envoyé avec succès !');

            // Tracking LinkedIn Conversion
            if (typeof window.lintrk === 'function') {
                window.lintrk('track', { conversion_id: 25895498 });
            }

            showThankYouMessage();
        };

        let handleFormError = (event) => {
            console.log('Erreur formulaire:', event.type);
        };

        let showThankYouMessage = () => {
            cache.formSection.style.opacity = '0';
            cache.formSection.style.transition = 'opacity 0.5s ease';
            
            setTimeout(() => {
                cache.formSection.style.display = 'none';
                cache.thankYouSection.style.display = 'block';
                cache.thankYouSection.style.opacity = '0';
                
                window.scrollTo({ top: 0, behavior: 'smooth' });
                
                setTimeout(() => {
                    cache.thankYouSection.style.transition = 'opacity 0.5s ease';
                    cache.thankYouSection.style.opacity = '1';
                }, 50);
            }, 500);
        };

        initFunc();
    }
}

export { ContactForm };
